(function () {
    const aniImages = document.querySelectorAll('.layout-2');
  
    for (let i = 0; i < aniImages.length; i++) {
        aniImages[i].addEventListener('onload', function(event) {
            event.target.classList.add('zoom');
        });
    }
})();
